import SvgPlayground from "./playground";

import "./playground.scss";

export default SvgPlayground;
